import {useMemo} from 'react';

import {MoneyCard} from '~/shared/services/bffService/api/interfaces/responses';
import {
  cancelMoneycardHandler,
  linkCreditCardHandler,
  manageBillingPermissions,
  moneycardLostOrStolen,
  moneycardWornOrNotWorking,
} from '~/personalArea/components/Sections/MyTenbis/actions';
import {MoneycardOtlRuleManagement} from '~/shared/store/models';

type UseMyTenbisActionsProps = {
  currentMoneycard: MoneyCard | null;
  otlData: MoneycardOtlRuleManagement | null;
  fetchOtl: () => Promise<void>;
};

const useMyTenbisActions = ({currentMoneycard, otlData, fetchOtl}: UseMyTenbisActionsProps) => {
  return useMemo(() => (!currentMoneycard ? [] : [
    {
      key: 'link_credit_card',
      caption: otlData?.otlRule.ruleActive && otlData?.otlRule.creditcardId ? 'credit_card_link_settings' : 'link_credit_card_to_10bis',
      onClick: () => {
        linkCreditCardHandler(currentMoneycard, otlData, fetchOtl);
      },
    },
    {
      key: 'billing_permissions',
      caption: 'manage_billing_permissions',
      onClick: () => {
        manageBillingPermissions(currentMoneycard);
      },
    },
    ...(!currentMoneycard.isWalletCard ? [
      {
        key: 'card_lost_or_stolen',
        caption: 'card_lost_or_stolen',
        onClick: () => {
          moneycardLostOrStolen(currentMoneycard);
        },
      },
      {
        key: 'card_worn_or_not_working',
        caption: 'card_worn_or_not_working',
        onClick: () => {
          moneycardWornOrNotWorking(currentMoneycard);
        },
      },
      {
        key: 'cancel_card',
        caption: 'cancel_10bis_card',
        onClick: () => {
          cancelMoneycardHandler(currentMoneycard);
        },
      },
    ] : []),
  ]), [currentMoneycard, otlData, fetchOtl]);
};

export default useMyTenbisActions;
